import { NOTES } from './data';
export default function Thesis() {
  return (
    <div className="bg-[#14110F] text-[#F8F4ED] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-6 lg:px-10 border-b border-[#2A241F]">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F59E0B] mb-3">— House thesis · 21 published research notes</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">The desk view.</h1>
      </section>
      <section className="max-w-[1100px] mx-auto px-6 lg:px-10 py-10 divide-y divide-[#2A241F]">
        {NOTES.map(n => (
          <article key={n.iss} className="grid md:grid-cols-[120px_1fr_auto] gap-6 py-9 items-baseline">
            <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F59E0B] bg-[#1F1A16] border border-[#F59E0B]/30 px-2 py-1 w-fit">No. {n.iss}</div>
            <div>
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#F8F4ED]/55">{n.date} · {n.cat}</p>
              <h2 className="font-serif italic text-3xl lg:text-5xl leading-[1.04] mt-2 text-[#F8F4ED]">{n.t}</h2>
            </div>
            <button data-testid={`aem-note-${n.iss}`} className="font-mono text-[10px] tracking-[0.32em] uppercase border border-[#F59E0B]/40 text-[#F59E0B] px-4 py-2.5 hover:bg-[#F59E0B] hover:text-[#14110F] transition-colors whitespace-nowrap">Read · {n.mins} min →</button>
          </article>
        ))}
      </section>
    </div>
  );
}
